import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 60px;
  margin-bottom: 30px;
  background: ${({ theme }) => theme.colors.gray200};
  border-radius: 4px;
`;

export const Salary = styled.div`
  margin-left: 10px;
  color: ${({ theme }) => theme.colors.gray900};
  ${getFontStyle('bold120_H5')};
`;
